import { Breakpoints } from '@/shared/styles/breakpoints';
import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';


export const Page = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${theme.ZrFontFamilyPrint};
`;

export const PageContent = styled.div`
    margin: 0px;
`;

export const HardwareSlidersContent = styled(PageContent)`
    padding: ${theme.ZrSpacingVerticalXxs};
`;

export const TitlePage = styled.p`
    font-family: ${theme.ZrFontFamilyDigitalLight};
    font-size: ${theme.ZrFontSizeSm}!important;
    color:${theme.ZrColorNeutralMedium02};
    margin-top: 10px !important;
`;

export const Rectangles = styled.div`
    padding: 2px 25px 2px 0;

    @media (max-width: ${Breakpoints.menu}) { 
        padding: 2px 2px 2px 2px;
    }
`;



export const Sidebar = styled.div`
    padding: 2px;
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: -o-sticky;
    position: sticky;
    height: max-content;
    top: 10px;
    bottom: auto;
`;
